// front/src/components/TodoReassignModal.jsx
import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { getTodoCibles, updateTodo } from '../api/todos';
import CibleSelector from './CibleSelector';

export default function TodoReassignModal({ open, todo, profileId, onClose, onDone }) {
  const [etabs, setEtabs] = useState([]);
  const [roles, setRoles] = useState([]);
  const [cibles, setCibles] = useState([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setErr('');
    (async () => {
      try {
        const tg = await getTodoCibles();
        setEtabs(tg.etablissements || []);
        setRoles(tg.roles || []);
        // pré-remplir avec les cibles actuelles de la tâche
        setCibles(
          (todo?.cibles || []).map((c) => ({ role: c.role, etablissementId: c.etablissement_id })),
        );
      } catch (e) {
        setErr(e.message);
      }
    })();
  }, [open, todo]);

  const submit = async () => {
    try {
      setErr('');
      if (!todo) return;
      if (!cibles.length) throw new Error('Ajoutez au moins une cible');
      setLoading(true);
      await updateTodo(todo.id, { cibles, profileId });
      onDone?.();
      onClose?.();
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Réaffecter la To Do"
      onClose={onClose}
      actions={
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="rounded-lg border px-3 py-2 text-sm hover:bg-slate-50"
          >
            Annuler
          </button>
          <button
            onClick={submit}
            disabled={loading}
            className="rounded-lg bg-[#A51A1F] text-white px-3 py-2 text-sm disabled:opacity-60"
          >
            {loading ? 'Envoi…' : 'Réaffecter'}
          </button>
        </div>
      }
    >
      {err && <div className="mb-3 text-sm text-red-600">{err}</div>}
      <div className="space-y-3">
        <label className="block text-sm text-slate-600">Cibles</label>
        <CibleSelector
          roles={roles}
          etabs={etabs}
          value={cibles}
          onChange={setCibles}
          emptyLabel="Aucune cible"
        />
      </div>
    </Modal>
  );
}
